<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">主题跑</div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="paramData">
            <el-form-item label="状态">
               <el-select placeholder="请选择状态" v-model="paramData.status">
                  <el-option label="全部状态" :value="-1"></el-option>
                  <el-option label="未发布" :value="0"></el-option>
                  <el-option label="已发布" :value="1"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="序号" width="80" prop="orderNum"></el-table-column>
            <el-table-column align="center" label="名称" prop="name"></el-table-column>
            <el-table-column align="center" label="列表图形" min-width="160">
               <template scope="{ row }">
                  <div class="flex-row-center margin-bottom-10">
                     <img class="table-img" :src="row.listImg" alt="">
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="链接" prop="jumpUrl"></el-table-column>
            <el-table-column align="center" label="要求">
               <template scope="{ row }">
                  <div>{{ handleRewardValue(row) }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="涉及校区">
               <template scope="{ row }">
                  <div>{{ row.type ? "部分" : "全部" }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="有效时间" width="180">
               <template scope="{ row }">
                  <div>{{ handleValidDate(row) }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
               <template scope="{ row }">
                  <div v-if="row.status === 0">未发布</div>
                  <div v-if="row.status === 1">已发布</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="最近操作时间">
               <template scope="{ row }">
                  <div>{{ new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss") }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180" fixed="right">
               <template scope="{ row }">
                  <div v-if="row.status == 0">
                     <el-button type="text" @click="clickPublish(row)">发布</el-button>
                     <el-button type="text" @click="clickEdit(row)">编辑</el-button>
                     <el-button type="text" style="color: red" @click="clickDelete(row)">删除</el-button>
                  </div>
                  <div v-else>
                     <el-button type="text" @click="clickDetail(row)">详情</el-button>
                     <el-button type="text" style="color: red" @click="clickRevoke(row)">撤销</el-button>
                  </div>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next, jumper" :current-page="paramData.pageNum"
            :page-size='paramData.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         paramData: {
            status: -1, //  -1全部，0:未发布,1:已发布
            pageNum: 1,
            pageSize: 10,
         },
         total: 0,
         listData: [],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/operate/activity/run/theme/list',
            method: 'POST',
            body: JSON.stringify(this.paramData)
         }).then((res) => {
            this.total = res.data.data.totalCount || 0;
            const list = res.data.data.list || [];
            this.listData = list.map((item) => {
               const rewardValue = item.rewardValue ? JSON.parse(item.rewardValue) : {};
               return {
                  ...item,
                  rewardValue
               }
            });
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 更新状态（发布或撤销）
      updateStatus(params) {
         let message = '确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容';
         let title = '发布';
         if (params.activityStatus === 0) {
            message = '确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容';
            title = '撤销';
         }
         this.$confirm(message, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/adminapi/v1/operate/activity/run/theme/updateStatus",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 发送删除
      sendDelete(params) {
         this.$confirm('确定要删除吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/adminapi/v1/operate/activity/run/theme/delete",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 点击重置
      clickReset() {
         this.paramData = {
            status: -1,
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },
      // 点击新增按钮
      clickAddition() {
         this.$router.push({
            path: '/yunying/activity/theme/detail',
            query: { actionType: 'add' }
         })
      },
      // 点击详情
      clickDetail(row) {
         this.$router.push({
            path: '/yunying/activity/theme/detail',
            query: { actionType: 'detail', id: row.id }
         })
      },
      // 点击编辑
      clickEdit(row) {
         this.$router.push({
            path: '/yunying/activity/theme/detail',
            query: { actionType: 'edit', id: row.id }
         })
      },
      // 点击发布
      clickPublish(row) {
         const params = {
            activityId: row.id,
            activityStatus: 1,
         };
         this.updateStatus(params);
      },
      // 点击撤销
      clickRevoke(row) {
         const params = {
            activityId: row.id,
            activityStatus: 0,
         };
         this.updateStatus(params);
      },
      // 点击删除
      clickDelete(row) {
         const params = {
            activityId: row.id
         };
         this.sendDelete(params);
      },
      // 切换当前页码
      changeCurrentPage(val) {
         this.paramData.pageNum = val;
         this.queryList();
      },
      // 处理要求
      handleRewardValue(row) {
         if (row.rewardType == 1) {
            return '跑步' + row.rewardValue.threshold + '次';
         } else {
            return '跑步' + row.rewardValue.threshold + '米, 每日最高计入' + row.rewardValue.oneDay + '米';
         }
      },
      // 处理有效时间
      handleValidDate(row) {
         let beginTime = '';
         if (row.beginTime) {
            beginTime = new Date(row.beginTime).format("yyyy-MM-dd hh:mm:ss");
         }
         let endTime = '';
         if (row.endTime) {
            endTime = new Date(row.endTime).format("yyyy-MM-dd hh:mm:ss");
         }
         if (beginTime && endTime) {
            return beginTime + ' - ' + endTime;
         } else {
            return beginTime || endTime || '';
         }
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// ThemeRunning.vue?3ccf2974